import * as React from "react";
import ReactDOM from "react-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const modalRoot = document.querySelector('#modal-root');

function ConfirmDialog({ title, message, visible, onConfirm, onCancel }) {
  const [open, setOpen] = React.useState(visible);

  const handleClose = () => {
    setOpen(false);
    onCancel();
  };

  const handleConfirm = () => {
    setOpen(false);
    onConfirm();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>取消</Button>
        <Button onClick={handleConfirm}>确定</Button>
      </DialogActions>
    </Dialog>
  );
}

const Confirm = ({
  title = '温馨提示', 
  message, 
  onConfirm = () => {}, 
  onCancel = () => {}
}) => {
  ReactDOM.unmountComponentAtNode(modalRoot)
  ReactDOM.render(<ConfirmDialog visible={true} onCancel={onCancel} onConfirm={onConfirm} title={title} message={message} />, modalRoot);
};

export default Confirm;
